<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Blog Details" pageTitle="Blog Details" />
            <BlogDetails />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import BlogDetails from '../BlogDetails/BlogDetails'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'BlogDetailsPage',
    components: {
        MainHeader,
        PageTitle,
        BlogDetails,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>